export const PREFETCH_TYPES = {
  DNS_PREFETCH: "dns-prefetch",
  PREFETCH: "prefetch",
  PRECONNECT: "preconnect"
};
